<template lang="pug">
.conversation-info-notes
  .seperator
  .conversation-info-notes-content.scroll
    .conversation-info-notes-item(v-for="note of notesList", :key="note.id")
      .conversation-info-notes-item-text
        span(v-html="noteContentFormatter(note.content)")
        aiq-button.clear__btn(link type="primary"
                              @click="remove(note.id)") clear
      .conversation-info-notes-item-date {{byAgent(note)}}&nbsp;
  aiq-input#new-note(size="small", type="textarea", :autosize="{maxRows: 2}", placeholder="Add notes", v-model="newNote", @keydown.enter.exact.prevent="add")
</template>

<script>
import dayjs from '@/localPlugins/dayjs';

const RELEASE_DATE = '2025-01-R199';
export default {
  name: 'notesList',
  props: {
    notes: {
      type: Array,
      required: true,
    },
  },
  emits: ['add', 'remove'],
  computed: {
    notesList() {
      return [...this.notes].reverse();
    },
  },
  data() {
    return {
      newNote: '',
    };
  },
  watch: {
    notes() {
      this.scrollToBottom();
    },
  },
  methods: {
    remove(id) {
      this.$emit('remove', id);
    },

    add() {
      if (!this.newNote.trim().length || this.newNote.trim() === '') {
        this.newNote = '';
        return;
      }
      this.$emit('add', this.newNote);
      this.newNote = '';
    },

    format(time) {
      return dayjs().isSame(dayjs(time), 'day') ? dayjs(time).calendar() : dayjs(time).format('lll');
    },

    scrollToBottom() {
      setTimeout(() => {
        const scrollableContainer = this.$el.querySelector('.scroll');
        scrollableContainer.scrollTop = scrollableContainer.scrollHeight;
      });
    },

    noteContentFormatter(content) {
      content = this.$filters.sanitize(content);
      content = this.$filters.url(content);
      return content;
    },

    /**
     * Format the agent that added the note
     *
     * @param {object} note - note object
     * @returns {string} formatted string
     */
    byAgent(note) {
      return note.agent ?
        this.$t('conversation_tab.side_panel.customer_info_accordion.customer_notes.note_added_by_agent',
          { agent_name: `${note.agent.profile.first_name} ${note.agent.profile.last_name}`, date: `${dayjs(note.created_at).format('MMM DD, YYYY hh:mm A')}` })
        : this.$t('conversation_tab.side_panel.customer_info_accordion.customer_notes.note_added_by_annonymous', { release_date: RELEASE_DATE });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../../../../styles/aiq-variables.scss";

.conversation-info-notes {
  width: 100%;
  font-weight: 300;
}

.seperator {
  margin: 10px 0px;
  border-top: 1px solid #dfe6ec
}

.conversation-info-notes-content {
  width: 100%;
  max-height: calc(100vh - 290px);
  margin-bottom: 10px;
}

.conversation-info-notes-item {
  margin-bottom: 10px;
  color: $aiq-text-conversation-info-notes-item;
  font-size: 12px;
  line-height: 12px;

  &:last-child {
    margin-bottom: 0;
  }
  &:hover {

    .md-icon {
      opacity: 1;
    }
  }
}
.conversation-info-notes-item-text {
  display: flex;
  align-items: center;
  white-space: normal;
  word-wrap: break-word;
  max-width: 260px;;

  .clear__btn {
    width: 12px;
    min-width: 12px;
    min-height: 12px;
    margin-left: 5px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
  }
}
.conversation-info-notes-item-date {
  margin-top: 2px;
  color: $aiq-text-conversation-info-notes-item-dage;
  font-size: 10px;
  line-height: 10px;
}
.md-input-container#new-note {
  .md-count {
   display: none;
  }
}
#new-note {
  margin-bottom: 10px;

  textarea {
    padding: 3px 10px;
    font-size: 12px;
    line-height: 14px;
    resize: none;

    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      border: 1px solid transparent;
      border-radius: 10px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 2px;
      background-color: transparent;
    }
    &:hover {
      border-color: #8391A5;

      &::-webkit-scrollbar-track {
        border-color: $aiq-bgc-scrollbar;
      }
      &::-webkit-scrollbar-thumb {
        background-color: $aiq-bgc-scrollbar;
      }
    }

    &:-ms-input-placeholder{
      color: #BFCBD9;
      font-size: 11px;
      line-height: 16px;
    }
    &::placeholder{
      color: #BFCBD9;
      font-size: 11px;
      line-height: 16px;
    }

    &:focus {
      border-color: #5A91E5;

      &::-webkit-input-placeholder {
        color: transparent;
      }
      &::-moz-placeholder {
        color: transparent;
      }
      &::-ms-placeholder {
        color: transparent;
      }
      &::-ms-input-placeholder {
        color: transparent;
      }
    }
  }
}

.inner-header {
  padding: 10px 0;
  color: #566682;
  font-size: 14px;
  line-height: 14px;
  font-weight: 300;
}
</style>

